import { Inject, Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { RouterBaseService } from '../router/router-base.service';
import { DataAnalyticsEvent, DataAnalyticsInitialData, DataAnalyticsModalData } from './data-analytics.domain';

import type { ModalRef } from '../../components/modal/modal-ref';

@Injectable({
  providedIn: 'root'
})
export class DataAnalyticsService {

  dataAnalyticsEvent: Subject<DataAnalyticsEvent> = new Subject<DataAnalyticsEvent>();
  dataAnalyticsEvents: Array<DataAnalyticsEvent> = [];
  private hasSentBaseEvent: boolean = false;
  private initData: DataAnalyticsInitialData;

  constructor(@Inject(RouterBaseService) private routerService: RouterBaseService) { }

  init(initData: DataAnalyticsInitialData): void {
    this.initData = initData;
    this.routerService.setDataAnalyticsHooks(this.initData)
      .subscribe((event: DataAnalyticsEvent) => this.emitEvent(event));
  }

  registerModalEvents(modalRef: ModalRef<unknown>, modaData: DataAnalyticsModalData): void {
    const modalOpenEvent: DataAnalyticsEvent = modaData?.dataAnlyticsEvent;
    const modalCloseEvent: DataAnalyticsEvent = this.initData?.modalCloseEvent;

    if(modalOpenEvent) {
      this.emitEvent(modalOpenEvent);

      if(modalCloseEvent) {
        const modalCloseSubscription = modalRef.afterClose().subscribe((): void => {
          this.emitEvent(modalCloseEvent);
          modalCloseSubscription.unsubscribe();
        });
      }
    }
  }

  emitEvent(event: DataAnalyticsEvent): void {
    let newEvent = { ...event };

    if(!this.hasSentBaseEvent) {
      newEvent = { ...this.initData?.baseEvent, ...newEvent };
      this.hasSentBaseEvent = true;
    }

    this.dataAnalyticsEvent.next(newEvent);
    this.dataAnalyticsEvents.push(newEvent);
  }

  emitLinkClickEvent(eventName: string, type: string = 'link'): void {
    const name = this.prefixEventName(eventName);
    this.emitEvent({
      event: 'linkClick',
      link: {
        name,
        type
      }
    });
  }

  prefixEventName(eventName: string): string {
    if (!eventName.startsWith(this.initData?.eventNamePrefix ?? '')) {
      eventName = `${this.initData.eventNamePrefix}:${eventName}`;
    }
    return eventName;
  }
}
